import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store' // 导入创建的 store
// import 'amfe-flexible'
import common from './utils/common'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueJsonEditor from 'vue-json-editor'
import mockData from "./mock/mock.js"
import http from "@/utils/http";
import { messageStatus} from "@/api/api";
Vue.prototype.$api = { messageStatus};

Vue.use(VueJsonEditor)
Vue.use(ElementUI);

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper);

ElementUI.Message.duration = 1000;
import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard);
import ErrorLogger from './utils/errorLogger'
Vue.prototype.$logger = ErrorLogger
Vue.config.productionTip = false
Vue.prototype.$mockData = mockData
Vue.prototype.$http = http;
Vue.prototype.$common = common;
new Vue({
  router,
  store, 
  render: h => h(App),
}).$mount('#app')
